import { ProjectsComponent } from './projects';
import { ProjectNewComponent } from './project-new/project-new';
import { ProjectContextComponent } from './project-context/project-context';
import { ProjectsListDataComponent } from './projects-list/projectsListData';

export default angular.module('projects', [])
    .component('projects', ProjectsComponent)
    .component('projectNew', ProjectNewComponent)
    .component('projectContext', ProjectContextComponent)
    .component('projectsListData', ProjectsListDataComponent)
    .constant('openProject', 'openProject');



// WEBPACK FOOTER //
// ./src/app/authorized/projects/index.js